// extracted by mini-css-extract-plugin
module.exports = {"cardModule":"CardModule_cardModule__z_uqs"};